// extracted by mini-css-extract-plugin
module.exports = {"container":"i_BD","tags":"i_BE","truncate":"i_BF","tag":"i_BG"};